import { render, staticRenderFns } from "./CreateFeed.vue?vue&type=template&id=5ae988e8&scoped=true"
import script from "./CreateFeed.vue?vue&type=script&lang=js"
export * from "./CreateFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae988e8",
  null
  
)

export default component.exports